import { apiClient } from './base/client';
import { ApiError } from './base/errors';
import type { UserSettings } from '../stores/userSettingsStore';

export interface userSettingsParams {
  profile?: string;
}

export async function fetchUserSettings(): Promise<UserSettings> {
  try {
    const endpoint = `/user/settings`;
    const response = await apiClient.get<UserSettings>(endpoint);

    return response;
  } catch (error) {
    throw new ApiError('Failed to fetch user settings');
  }
}


export async function updateUserSettings(settings: Partial<UserSettings>): Promise<UserSettings> {
    try {
        const endpoint = `/user/settings`;
        const response = await apiClient.patch<UserSettings>(endpoint, settings);

        return response;
    } catch (error) {
        throw new ApiError('Failed to update user settings');
    }
}
